import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { of, switchMap } from 'rxjs';
import { ClientAuthService, NotificationService } from 'proleis-web-app';
import { tap } from 'rxjs/operators';
import { RestoreUrlService } from './restore.url.service';
import { TranslateService } from '@ngx-translate/core';
import { HandleAuthErrorServiceService } from './handle.auth.error.service.service';

export const AuthGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
) => {
  const clientAuth = inject(ClientAuthService);
  const router = inject(Router);
  const urlService = inject(RestoreUrlService);
  const notificationService = inject(NotificationService);
  const translate: TranslateService = inject(TranslateService);
  const authErrorService = inject(HandleAuthErrorServiceService);

  clientAuth.validateAuth();
  return clientAuth.isAuthenticated$.pipe(
    switchMap((isAuthenticated) => {
      if (isAuthenticated) {
        if (route.data.permissions) {
          return clientAuth.checkPermissions(route.data.permissions).pipe(
            tap((permissions) => {
              if (!permissions) {
                notificationService.showNotification(
                  translate.instant('general.notifications.sessionExpired'),
                );
              }
            }),
          );
        }
        return of(true);
      } else {
        authErrorService.handleAuthError(route.url);
        return of(false);
      }
    }),
    tap((isAuthenticated) => {
      if (!isAuthenticated) {
        urlService.addUrl(route.url);
        router.navigate(['home']).then();
      }
    }),
  );
};
